import Toast from '@core/components/Toast';
import Application from '@app/Application';
var app = new Application();
export var TC = {
    App: app,
    Toast: Toast,
    Api: app.api
};
// Shortcut to current view js
Object.defineProperty(TC, 'View', {
    get: function () { return app.currentView; }
});
// Temporarily relocated to fix Vue issues
document.addEventListener('DOMContentLoaded', function () {
    var $navbarBurgers = [].slice.call(document.querySelectorAll('.navbar-burger'), 0);
    if ($navbarBurgers.length > 0) {
        $navbarBurgers.forEach(function ($el) {
            $el.addEventListener('click', function () {
                var target = $el.dataset.target;
                var $target = document.getElementById(target);
                $el.classList.toggle('is-active');
                $target.classList.toggle('is-expanded');
                var bodyElem = document.getElementsByTagName('BODY')[0];
                bodyElem.classList.remove('mini-navbar');
            });
        });
    }
    var dropdown = document.querySelector('.dropdown');
    if (dropdown) {
        dropdown.addEventListener('click', function (event) {
            event.stopPropagation();
            dropdown.classList.toggle('is-active');
        });
    }
});
